import React, { useRef, useState, useEffect } from 'react'
import { Button } from 'carbon-components-react'
import { Close, Maximize, Minimize } from '@carbon/icons-react'
import { KnovaText } from '../BasicUIComponents/KnovaText'
import { BotAssistSettings } from '../UIUtilsFiles/BotAssistSettings'
import { FEEDBACK_BOT, SEQUENCE_BOT, TUTOR_BOT } from '../constants'
import SCMultiInput from '../SCInteractComponents/SCMultiInput'
import SCEPMultiInput from '../SCInteractComponents/SCEPMultiInput'

function ExtraPracticeModal(props) {
  const {
    extraPracticeData,
    themeProperties,
    sketchPadInitial,
    sketchPadDataArray,
    textAreaData
  } = props
  const {
    onCloseClick,
    getTutorTalking,
    onSketchDataCapture,
    onSketchDisplayed,
    onTextAreaDataCapture
  } = props

  //Tutor variables
  const [botAudioData, setBotAudioData] = useState('')
  const [ttsData, setTtsData] = useState([])
  const [tutorialStart, setTutorialStart] = useState(false)
  const [isSubtitle, setIsSubtitle] = useState(true)
  const [isTutorPlayed, setIsTutorPlayed] = useState(false)
  const [ttsPlayType, setTtsPlayType] = useState('')
  const [feedbackType, setFeedbackType] = useState('')
  const [isAudioForcedStopped, setIsAudioForcedStopped] = useState(false)
  const [isAudioPlaying, setIsAudioPlaying] = useState(true)

  //Component data variable
  const [isInitialBotPlayed, setIsInitialBotPlayed] = useState(false)
  const [priorityActive, setPriorityActive] = useState(-1)
  const [isNextMove, setIsNextMove] = useState(false)

  useEffect(() => {
    console.log('extraPracticeData', extraPracticeData)
    if (Object.keys(extraPracticeData).length > 0) {
      checkTutorInstructions()
    }
  }, [extraPracticeData])

  //check tutor message is available and play
  function checkTutorInstructions() {
    let botTtsData = getTutorAudio()
    if (botTtsData.tutorTtsAudio !== '') {
      setTtsPlayType(TUTOR_BOT)
      setBotAudioData(botTtsData.tutorTtsAudio)
      setTutorialStart(true)
    } else {
      setTutorialStart(false)
      setIsTutorPlayed(true)
    }
    if (botTtsData.tutorTtsText !== '') {
      setTtsData(botTtsData.tutorTtsText)
    }
  }

  //Get initial instructions data
  function getTutorAudio() {
    let tutorBotData = {
      tutorTtsAudio: '',
      tutorTtsText: []
    }
    if (extraPracticeData.SpeechAudioData) {
      let activityInitialInstruction = extraPracticeData.SpeechAudioData
      if (activityInitialInstruction.speechAudioLink) {
        tutorBotData.tutorTtsAudio = activityInitialInstruction.speechAudioLink
      }
      if (activityInitialInstruction.speechAudioLink) {
        tutorBotData.tutorTtsText = activityInitialInstruction.speechData
      }
    }
    return tutorBotData
  }

  useEffect(() => {
    if (isTutorPlayed) {
      setBotAudioData('')
      setPriorityActive(1)
    }
  }, [isTutorPlayed])

  useEffect(() => {
    if (priorityActive > -1) {
      if (priorityActive <= extraPracticeData.Options.length) {
        handlePriorityChange(SEQUENCE_BOT)
      } else {
        setTutorialStart(false)
        setBotAudioData('')
      }
    }
  }, [priorityActive])

  function handlePriorityChange(callType) {
    let componentSpeechData = getCurrentComponentSpeechData(
      extraPracticeData.Options[priorityActive - 1]
    )
    if (componentSpeechData.speechAudioLink !== '') {
      setTtsPlayType(SEQUENCE_BOT)
      setBotAudioData(componentSpeechData.speechAudioLink)
      setTtsData(componentSpeechData.speechData)
      if (callType === SEQUENCE_BOT) {
        setTutorialStart(true)
      }
    }
  }

  function getCurrentComponentSpeechData(currentComponentData) {
    let componentSpeechData = {
      speechAudioLink: '',
      speechAudioTimeStamps: [],
      speechData: []
    }
    if (currentComponentData) {
      if (currentComponentData.SpeechAudioData) {
        componentSpeechData.speechAudioLink =
          currentComponentData.SpeechAudioData.speechAudioLink
        componentSpeechData.speechData =
          currentComponentData.SpeechAudioData.speechData
      }
    }

    return componentSpeechData
  }

  function handleValueChange() {}

  function onPriorityChange() {}

  function handleSucAndFailFeedback(feedbackType, feedbackMessage) {
    if (feedbackType) {
      setFeedbackType('success')
      if (
        feedbackMessage.successAudioLink &&
        feedbackMessage.successAudioLink !== ''
      ) {
        setTtsPlayType(FEEDBACK_BOT)
        setBotAudioData(feedbackMessage.successAudioLink)
        setTtsData(feedbackMessage.successFeedback)
        setTutorialStart(true)
      } else {
        setTutorialStart(false)
        setPriorityActive((priorityActive) => priorityActive + 1)
      }
    } else {
      setFeedbackType('failure')
      if (
        feedbackMessage.failureAudioLink &&
        feedbackMessage.failureAudioLink !== ''
      ) {
        setTtsPlayType(FEEDBACK_BOT)
        setBotAudioData(feedbackMessage.failureAudioLink)
        setTtsData(feedbackMessage.failureFeedback)
        setTutorialStart(true)
      } else {
        setTutorialStart(false)
      }
    }
  }

  function renderSketchArea() {
    return (
      <div className='sketch-area-cont'>
        <SCEPMultiInput
          isPractice={true}
          Completed={0}
          isActive={true}
          componentData={extraPracticeData}
          themeColors={themeProperties.themeColors}
          themeFont={themeProperties.themeFont}
          isSideMenu={false}
          isFollowTheFlow={true}
          priorityActive={priorityActive}
          // defaultValue={componentDefaultValue}
          layoutType={10}
          isOutsideClick={false}
          onValueChange={handleValueChange}
          getCurrentSelectedOption={(data) => {
            //getCurrentSelectedOption(data)
          }}
          onPriorityChange={() => {
            setIsNextMove(false)
            setPriorityActive((priorityActive) => priorityActive + 1)
          }}
          handleSucAndFailFeedback={handleSucAndFailFeedback}
          isAudioPlaying={!isAudioPlaying}
          isMinimize={false}
          isReplaying={false}
          isExtraPractice={true}
          isNextMove={isNextMove}
        />
      </div>
    )
  }

  return (
    <div className='extra-prac-modal'>
      <div className='extra-prac-modal-container'>
        <div className='modal-header-cont'>
          <div className='heading-text-cont'>
            <KnovaText
              text={
                extraPracticeData.FinalQuestion &&
                extraPracticeData.FinalQuestion.question
              }
              textColor='#FFFFFF'
              textMargin='0px'
            />
          </div>
          <div className='heading-button-cont'>
            <Button
              className='heading-icon'
              hasIconOnly
              iconDescription='Close'
              renderIcon={Close}
              tooltipAlignment='center'
              tooltipPosition='bottom'
              onClick={() => {
                onCloseClick()
                // if (!displayWalkThrough) {
                //   onCloseClick()
                // }
              }}
            />
          </div>
        </div>
        <div
          className='modal-body-cont'
          style={{
            backgroundImage:
              themeProperties && `url(${themeProperties.themeImage})`,
            backgroundColor: themeProperties.themeColors.background
          }}
        >
          {renderSketchArea()}
        </div>
        {botAudioData !== '' && (
          <BotAssistSettings
            audioUrl={botAudioData}
            text={ttsData}
            tutorialStart={tutorialStart}
            botType={ttsPlayType}
            getTutorTalking={(audioStatus) => {
              setIsAudioPlaying(audioStatus)
              getTutorTalking(audioStatus)
            }}
            isAudioForcedStopped={isAudioForcedStopped}
            isMinimize={false}
            onBotComplete={() => {
              setTutorialStart(false)
              setIsTutorPlayed(true)
              if (ttsPlayType === SEQUENCE_BOT) {
                //checkAndMoveNextComponent()
              } else if (ttsPlayType === FEEDBACK_BOT) {
                if (feedbackType === 'success') {
                  if (extraPracticeData.OperationType === 'pemdas') {
                    setPriorityActive((priorityActive) => priorityActive + 1)
                  } else {
                    handlePriorityChange(FEEDBACK_BOT)
                    setIsNextMove(true)
                    setTimeout(() => {
                      setIsNextMove(false)
                    }, 100)
                  }
                } else {
                  handlePriorityChange(FEEDBACK_BOT)
                }
              }
            }}
            onBotStopped={() => {
              setTutorialStart(false)
            }}
            onFrwdSkipClick={() => {}}
            isExtraPractice={true}
          />
        )}
      </div>
    </div>
  )
}
export { ExtraPracticeModal }
